import api from '../../api'
import { useEffect, useState } from 'react'
import Title from "../../components/title";
import styles from './style.module.css'
import { Breadcrumbs } from '../../components';

const FlatPages = () => {
    const curPath = window.location.pathname
    const [flatpage, setFlatPage] = useState([])
    useEffect(() => {
        api.getFlatPage()
            .then((data) => {
                setFlatPage(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        flatpage.results?.map((page) => {
            if (page.url === curPath) {
                return (
                    <>
                        <Title title={page.title} />
                        <Breadcrumbs urls={[{ title: page.title, path: '' }]} />
                        <div className={styles.flatpage__content} dangerouslySetInnerHTML={{__html: page.content}} />
                    </>
                );
            }
            return null;
          })          
    );
}

export default FlatPages;